import { Controller } from "@hotwired/stimulus";

import { FilePondRails, FilePond } from "../helpers/filepond-rails";

// Connects to data-controller="file-pond"
export default class extends Controller {
  static targets = ["input", "form"];

  connect() {
    if (this.hasInputTarget) {
      this.pond = FilePondRails.create(this.inputTarget);
      this.pond.setOptions({
        labelIdle: `<wa-animation delay="0" direction="normal" duration="2000" easing="easeInOutQuad" end-delay="5000" fill="auto" iteration-start="0" iterations="1000000" name="jello" play="" playback-rate="1"><wa-icon family="sharp-duotone" label="" library="default" name="cassette-tape" variant="thin" class="wa-caption-l fa-flip" style="font-size: 8rem" aria-hidden="true"></wa-icon></wa-animation><p class="wa-heading-m">Drag & Drop your Audio track or <span class="filepond--label-action"> Browse </span></p>`,
      });
    }
  }

  disconnect() {
    this.pond.destroy();
  }

  processForm() {
    this.pond.setOptions({ disabled: true });
    this.formTarget.requestSubmit();
  }
}
